import React from "react";
import { connect } from "react-redux";
import { logout } from "../../actions/authAction/loginAction";
import UserAvatar from "../../components/UserAvatar";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "../ThemeToggle";
import StoreBrandLogo from "../StoreBrandLogo";
import PATH_URL from "../../routers/path";
import OutletSwitcher from "../OutletSwitcher";

const Navbar = (props) => {
  const { logout, userProfile, storeSetting, isSidebarExpanded = false, onToggleSidebar } = props;
  const location = useLocation();
  const pathname = location.pathname;
  const isPosPage = pathname === PATH_URL.POS || pathname?.startsWith(`${PATH_URL.POS}/`);
  const displayName = userProfile?.name || userProfile?.username || userProfile?.email || "User";
  const roleName = userProfile?.role || userProfile?.role_name || "";
  const hasAccessibleOutlet = Array.isArray(userProfile?.outlets)
    && userProfile.outlets.some((outlet) => outlet?.is_active !== false);

  return (
    <header
      className={`navbar navbar-expand-md d-flex d-print-none bug-body shadow-none app-navbar ${
        isPosPage ? "pos-navbar" : "dashboard-navbar"
      }`}>
      <div className="container-xl">
        <div className="d-flex align-items-center gap-2">
          {!isPosPage ? (
            <button
              className="navbar-toggler d-lg-none border-0"
              type="button"
              aria-controls="sidebar-menu"
              aria-expanded={isSidebarExpanded}
              aria-label={isSidebarExpanded ? "Tutup navigasi" : "Buka navigasi"}
              onClick={onToggleSidebar}>
              <span className="navbar-toggler-icon"></span>
            </button>
          ) : null}

          <div className={`navbar-brand navbar-brand-autodark p-0 ${isPosPage ? "ms-2" : "d-lg-none"}`}>
            <Link to={isPosPage ? PATH_URL.SALE : PATH_URL.DASHBOARD} className="d-flex align-items-center">
              <StoreBrandLogo
                storeSetting={storeSetting}
                variant={isPosPage ? "pos" : "navbar"}
                style={isPosPage ? {} : { maxHeight: "2.25rem", minHeight: "2.25rem", width: "auto" }}
              />
            </Link>
          </div>
        </div>
        <div className="navbar-nav flex-row align-items-center ms-auto">
          <OutletSwitcher
            userProfile={userProfile}
            compact={isPosPage}
            className="d-none d-md-flex"
          />
          <div className="d-flex">
            <div className="nav-item me-2">
              <ThemeToggle className="nav-link px-2 rounded-3" showLabel={false} />
            </div>
            {/* <div className="nav-item dropdown d-none d-md-flex">
              <button
                type="button"
                className="nav-link px-0 border-0 bg-transparent"
                data-bs-toggle="dropdown"
                tabIndex="-1"
                aria-label="Show notifications"
                data-bs-auto-close="outside"
                aria-expanded="false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-1">
                  <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
                  <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
                </svg>
                <span className="badge bg-red"></span>
              </button>
              <div className="dropdown-menu dropdown-menu-arrow dropdown-menu-end dropdown-menu-card">
                <div className="card">
                  <div className="card-header d-flex">
                    <h3 className="card-title">Notifications</h3>
                    <div className="btn-close ms-auto" data-bs-dismiss="dropdown"></div>
                  </div>
                  <div className="list-group list-group-flush list-group-hoverable">
                    <div className="list-group-item">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <span className="status-dot status-dot-animated bg-red d-block"></span>
                        </div>
                        <div className="col text-truncate">
                          <span className="text-body d-block">Example 1</span>
                          <div className="d-block text-secondary text-truncate mt-n1">
                            Change deprecated html tags to text decoration classes (#29604)
                          </div>
                        </div>
                        <div className="col-auto">
                          <button type="button" className="list-group-item-actions border-0 bg-transparent p-0">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon text-muted icon-2">
                              <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <span className="status-dot d-block"></span>
                        </div>
                        <div className="col text-truncate">
                          <span className="text-body d-block">Example 2</span>
                          <div className="d-block text-secondary text-truncate mt-n1">
                            justify-content:between ⇒ justify-content:space-between (#29734)
                          </div>
                        </div>
                        <div className="col-auto">
                          <button type="button" className="list-group-item-actions show border-0 bg-transparent p-0">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon text-yellow icon-2">
                              <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <span className="status-dot d-block"></span>
                        </div>
                        <div className="col text-truncate">
                          <span className="text-body d-block">Example 3</span>
                          <div className="d-block text-secondary text-truncate mt-n1">
                            Update change-version.js (#29736)
                          </div>
                        </div>
                        <div className="col-auto">
                          <button type="button" className="list-group-item-actions border-0 bg-transparent p-0">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon text-muted icon-2">
                              <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item">
                      <div className="row align-items-center">
                        <div className="col-auto">
                          <span className="status-dot status-dot-animated bg-green d-block"></span>
                        </div>
                        <div className="col text-truncate">
                          <span className="text-body d-block">Example 4</span>
                          <div className="d-block text-secondary text-truncate mt-n1">
                            Regenerate package-lock.json (#29730)
                          </div>
                        </div>
                        <div className="col-auto">
                          <button type="button" className="list-group-item-actions border-0 bg-transparent p-0">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon text-muted icon-2">
                              <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col">
                        <button type="button" className="btn btn-2 w-100">
                          {" "}
                          Archive all{" "}
                        </button>
                      </div>
                      <div className="col">
                        <button type="button" className="btn btn-2 w-100">
                          {" "}
                          Mark all as read{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nav-item dropdown d-none d-md-flex me-3">
              <button
                type="button"
                className="nav-link px-0 border-0 bg-transparent"
                data-bs-toggle="dropdown"
                tabIndex="-1"
                aria-label="Show app menu"
                data-bs-auto-close="outside"
                aria-expanded="false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-1">
                  <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                  <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                  <path d="M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                  <path d="M14 7l6 0" />
                  <path d="M17 4l0 6" />
                </svg>
              </button>
              <div className="dropdown-menu dropdown-menu-arrow dropdown-menu-end dropdown-menu-card">
                <div className="card">
                  <div className="card-header">
                    <div className="card-title">My Apps</div>
                    <div className="card-actions btn-actions">
                      <button type="button" className="btn-action border-0 bg-transparent p-0">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-1">
                          <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                          <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="list-group">
                      <button
                        type="button"
                        className="list-group-item list-group-item-action border-0 text-start w-100">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <div>My Apps</div>
                            <div className="text-muted small">123 new apps</div>
                          </div>
                          <div className="btn-close" data-bs-dismiss="dropdown"></div>
                        </div>
                      </button>
                      <button
                        type="button"
                        className="list-group-item list-group-item-action border-0 text-start w-100">
                        <div className="d-flex flex-row-reverse">
                          <div className="flex-grow-1">
                            <div>My Apps</div>
                            <div className="text-muted small">123 new apps</div>
                          </div>
                          <div className="btn-close" data-bs-dismiss="dropdown"></div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          <div className="nav-item dropdown">
            <button
              type="button"
              className="nav-link d-flex lh-1 p-0 px-2 border-0 bg-transparent"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-label="Open user menu">
              <UserAvatar
                fullName={displayName}
                imageUrl={userProfile?.image}
                size="sm"
                className=""
                justPhotoView={true}
              />
              <div className="d-none d-xl-block ps-2">
                <div>{displayName}</div>
                <div className="mt-1 small text-secondary">{roleName}</div>
              </div>
            </button>
            <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow akas-user-menu">
              {hasAccessibleOutlet ? (
                <>
                  <div className="d-md-none outlet-switcher-menu-shell">
                    <OutletSwitcher userProfile={userProfile} compact={isPosPage} menu />
                  </div>
                  <div className="d-md-none dropdown-divider outlet-switcher-menu-divider"></div>
                </>
              ) : null}
              <Link to={PATH_URL.PROFILE} className="dropdown-item">
                Profil Akun
              </Link>
              <div className="dropdown-divider"></div>
              <button type="button" className="dropdown-item cursor-pointer" onClick={() => logout()}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  storeSetting: state?.stores?.setting,
});

export default connect(mapStateToProps, {
  logout,
})(Navbar);
